/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return void
 */
export function initializeBlock(block) {
  jQuery(".variations_form").on(
    "woocommerce_variation_select_change",
    function () {
      const figures: NodeListOf<HTMLElement> = block.querySelectorAll(
        ".wp-block-site-product-detail-image__figure-link",
      );

      for (var i = 0; i < figures.length; i++) {
        figures[i].style.display = "none";
      }

			const figure: HTMLElement | null = block.querySelector(
        `.wp-block-site-product-detail-image__figure-link:first-child`,
      );

      if (figure) {
        figure.style.display = "block";
      }
    },
  );

  jQuery(".single_variation_wrap").on(
    "show_variation",
    function (event, variation) {
      const variation_id = variation.variation_id;

			const figures: NodeListOf<HTMLElement> = block.querySelectorAll(
        `.wp-block-site-product-detail-image__figure-link:not(.product-${variation_id})`,
      );

			for (var i = 0; i < figures.length; i++) {
        figures[i].style.display = "none";
      }

      const figure: HTMLElement | null = block.querySelector(
        `.wp-block-site-product-detail-image__figure-link.product-${variation_id}`,
      );

      if (figure) {
        figure.style.display = "block";
      }
    },
  );
}
